// extracted by mini-css-extract-plugin
module.exports = {"container":"Kk-z","header":"Lk-z","details":"Mk-z","link":"Nk-z"};